import { useEffect, useState } from 'react'
import AnimationLayout from './components/AnimationLayout'

interface Badge {
  name: string
  emoji: string
  description: string
  points_awarded: number
}

interface Props {
  animation: { id: number; name: string; description: string }
  badge: Badge
  all_animations: { id: number; name: string }[]
}

export default function Animation6({ animation, badge, all_animations }: Props) {
  const [showBadge, setShowBadge] = useState(false)

  useEffect(() => {
    setTimeout(() => setShowBadge(true), 200)
  }, [])

  return (
    <AnimationLayout animation={animation} allAnimations={all_animations}>
      <style>{`
        @keyframes pulseGlow {
          0%, 100% {
            box-shadow: 0 0 20px rgba(255, 241, 152, 0.5),
                        0 0 40px rgba(255, 241, 152, 0.3),
                        0 0 60px rgba(255, 241, 152, 0.2);
            transform: scale(1);
          }
          50% {
            box-shadow: 0 0 40px rgba(255, 241, 152, 0.8),
                        0 0 80px rgba(255, 241, 152, 0.5),
                        0 0 120px rgba(255, 241, 152, 0.3);
            transform: scale(1.05);
          }
        }
        @keyframes ringPulse {
          0% {
            transform: scale(0.8);
            opacity: 1;
          }
          100% {
            transform: scale(2);
            opacity: 0;
          }
        }
        .pulse-container {
          animation: pulseGlow 1.5s ease-in-out infinite;
        }
        .ring {
          animation: ringPulse 2s ease-out infinite;
        }
      `}</style>

      <div className="flex flex-col items-center justify-center min-h-[50vh] sm:min-h-[60vh]">
        <div className={`relative transition-all duration-500 ${showBadge ? 'opacity-100 scale-100' : 'opacity-0 scale-50'}`}>
          {/* Anneaux de pulsation */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="ring absolute w-48 h-48 rounded-full border-4 border-tessan-yellow/50" style={{ animationDelay: '0s' }} />
            <div className="ring absolute w-48 h-48 rounded-full border-4 border-tessan-cream/50" style={{ animationDelay: '0.5s' }} />
            <div className="ring absolute w-48 h-48 rounded-full border-4 border-tessan-yellow/30" style={{ animationDelay: '1s' }} />
          </div>

          {/* Badge central */}
          <div className="pulse-container w-48 h-48 bg-tessan-cream rounded-2xl flex items-center justify-center relative z-10">
            <span className="text-6xl sm:text-8xl">{badge.emoji}</span>
          </div>
        </div>

        <div className={`mt-8 text-center transition-all duration-700 delay-500 ${showBadge ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
          <div className="text-2xl sm:text-4xl font-black text-tessan-yellow">{badge.name}</div>
          <div className="text-lg sm:text-xl text-tessan-cream mt-2">+{badge.points_awarded} points</div>
          <div className="text-tessan-cream/70 mt-4 max-w-[280px] sm:max-w-xs">{badge.description}</div>
        </div>
      </div>
    </AnimationLayout>
  )
}
